import clsx from 'clsx';

function resolveVariants(defaultVariants, activeVariants) {
  const result = { ...defaultVariants
  };

  for (const key in activeVariants) {
    const value = activeVariants[key];
    if (value === void 0) continue;
    result[key] = value;
  }

  return result;
}

function twix(_ref) {
  let {
    base,
    variants,
    defaultVariants,
    compoundVariants = []
  } = _ref;
  return _ref2 => {
    let {
      class: _class,
      ...activeVariants
    } = _ref2;
    const resolvedVariants = resolveVariants(defaultVariants, activeVariants);
    const classes = [];

    for (const key in resolvedVariants) {
      const value = resolvedVariants[key];
      if (!value) continue;
      classes.push(variants[key][value]);
    }

    for (const compoundV of compoundVariants) {
      let shouldIncludeCompoundVariant = true;

      for (const [key, value] of Object.entries(compoundV)) {
        if (key === "class") continue;

        if (resolvedVariants[key] !== value) {
          shouldIncludeCompoundVariant = false;
        }
      }

      if (shouldIncludeCompoundVariant) {
        classes.push(compoundV.class);
      }
    }

    return clsx(classes, base, _class);
  };
}

export { twix };